"use client";

import { useCallback, useRef, type MutableRefObject } from "react";
import type { TeamData } from "../Cteamcard";
import { getOriginalTeamIndex } from "./carouselMath";

interface UseCarouselSnapReporterInput {
  onCenteredTeamChangeRef: MutableRefObject<
    ((team: TeamData | null, index: number) => void) | undefined
  >;
  originalLength: number;
  teams: TeamData[];
}

export function useCarouselSnapReporter({
  onCenteredTeamChangeRef,
  originalLength,
  teams,
}: UseCarouselSnapReporterInput): {
  lastReportedTeamIdRef: MutableRefObject<string | null>;
  reportSnap: (doubledIndex: number) => void;
} {
  const lastReportedTeamIdRef = useRef<string | null>(null);
  const reportSnap = useCallback(
    (doubledIndex: number): void => {
      const teamIndex = getOriginalTeamIndex({
        doubledIndex,
        originalLength,
      });
      const team = teams[teamIndex] ?? null;
      const teamId = team?.id ?? null;
      if (teamId === lastReportedTeamIdRef.current) return;

      lastReportedTeamIdRef.current = teamId;
      onCenteredTeamChangeRef.current?.(team, teamIndex);
    },
    [onCenteredTeamChangeRef, originalLength, teams],
  );

  return {
    lastReportedTeamIdRef,
    reportSnap,
  };
}
